import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-primary-500">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-white">
          开启您的私密观影之旅
        </h2>
        <p className="mt-4 text-white/80 text-sm leading-relaxed max-w-xl mx-auto">
          无论您是初次体验还是资深爱好者，我们都为您提供最专业的观影指南。立即浏览我们的内容，做出明智选择。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/selection-guide"
            className="px-8 py-3 bg-white text-primary-600 font-medium rounded-md hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            浏览选择指南
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-primary-600 text-white font-medium rounded-md hover:bg-primary-700 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm border border-primary-400"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}